import {initializeApp} from "firebase/app";
import {connectAuthEmulator, getAuth} from "firebase/auth";
import {connectStorageEmulator, getStorage} from 'firebase/storage';
import {
	connectFirestoreEmulator,
	deleteDoc as firebaseDeleteDoc,
	doc as firestoreDoc,
	getFirestore,
	query as firestoreQuery,
	updateDoc as firestoreUpdateDoc,
	where as firestoreWhere
} from 'firebase/firestore';

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? "AIzaSyBHzZWkqbAXc5qxhL78iKRjjap3JJ7ILfE",
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? "myworkspace-8c820.firebaseapp.com",
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ?? "myworkspace-8c820",
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? "myworkspace-8c820.appspot.com",
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? "948183443118",
	appId: process.env.REACT_APP_FIREBASE_APP_ID ?? "1:948183443118:web:79e2add833dc979f1bef3f"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const doc = firestoreDoc;
export const updateDoc = firestoreUpdateDoc;
export const query = firestoreQuery;
export const deleteDoc = firebaseDeleteDoc;
export const where = firestoreWhere;

const shouldUseEmulator = process.env.REACT_APP_USE_FIREBASE_EMULATOR === 'true';
if (shouldUseEmulator) {
	const firestoreHost = process.env.FIRESTORE_EMULATOR_HOST ?? '127.0.0.1:8080';
	const authHost = process.env.FIREBASE_AUTH_EMULATOR_HOST ?? '127.0.0.1:9099';
	const storageHost = process.env.FIREBASE_STORAGE_EMULATOR_HOST ?? '127.0.0.1:9199';

	const [firestoreHostname, firestorePort] = firestoreHost.split(':');
	const [authHostname, authPort] = authHost.split(':');
	const [storageHostname, storagePort] = storageHost.split(':');

	connectFirestoreEmulator(db, firestoreHostname, Number(firestorePort));
	connectAuthEmulator(auth, `http://${authHostname}:${authPort}`);
	connectStorageEmulator(storage, storageHostname, Number(storagePort));
}
